import type { ReactNode } from 'react';

/**
 * One key/value row of a `.kv` readout (Master list header, a case's decision). `clip`: an id,
 * a date, a version — one line, cut with an ellipsis, the whole value in the tooltip; never
 * broken mid-token (UX review P1-1). The layout is `.kv` / `.kv-row` in styles.css.
 */
export function Kv({ k, v, mono, clip, testid }: { k: string; v: ReactNode; mono?: boolean; clip?: boolean; testid?: string }) {
  const cls = ['v', mono ? 'mono' : '', clip ? 'clip' : ''].filter(Boolean).join(' ');
  return (
    <div className="kv-row">
      <span className="k">{k}</span>
      <span className={cls} data-testid={testid} title={clip && (typeof v === 'string' || typeof v === 'number') ? String(v) : undefined}>
        {v}
      </span>
    </div>
  );
}
